import { useSearchParams, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");
  return (
    <div data-testid="payment-cancel-page" className="max-w-xl mx-auto px-6 py-24 text-center">
      <XCircle className="w-14 h-14 mx-auto text-[color:var(--accent)]" />
      <h1 className="font-serif text-4xl mt-6">Payment cancelled</h1>
      <p className="text-[color:var(--text-muted)] mt-3">No charge was made. You can retry the deposit whenever you're ready.</p>
      <div className="mt-8 flex gap-3 justify-center">
        {bookingId && (
          <Link to={`/bookings/${bookingId}`}>
            <Button data-testid="back-to-booking-btn" className="btn-sage rounded-full h-11 px-6">Back to booking</Button>
          </Link>
        )}
        <Link to="/planner/dashboard"><Button variant="outline" className="rounded-full h-11 px-6">Dashboard</Button></Link>
      </div>
    </div>
  );
}
